var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.tags.length
    ? _c(
        "div",
        {
          staticClass:
            "reviews-tags bg-gray-40 rounded-20 d-flex flex-column overflow-hidden",
          class: _setup.isMobile ? "py-4" : "py-6",
          attrs: { "data-qa": "reviews_tags" },
        },
        [
          _c(
            "div",
            {
              staticClass: "text-body-1 text--text mb-2",
              class: _setup.isMobile ? "px-4" : "px-6",
              attrs: { "data-qa": "reviews_tags_title" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.tStatic("Пациенты упоминали в отзывах")) +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c(_setup.CoreSwiper, {
            staticClass: "reviews-tags__swiper",
            attrs: {
              "slides-per-view": "auto",
              "space-between": _setup.isMobile ? 8 : 16,
              "slides-offset-before": _setup.isMobile ? 16 : 24,
              "slides-offset-after": _setup.isMobile ? 16 : 24,
              "has-pagination": false,
              "has-navigation": !_setup.isMobile,
              "auto-height": false,
              "free-mode": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "slides",
                  fn: function ({ slideAttrs }) {
                    return _vm._l(_vm.tags, function (tag) {
                      return _c(
                        "div",
                        _vm._b({ key: tag.translit }, "div", slideAttrs, false),
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "reviews-tags__card elevation-1 bg-gray-0 rounded-15 pa-4 d-flex flex-column ga-2",
                              attrs: {
                                type: "button",
                                "data-qa": "reviews_tags_slide",
                              },
                              on: {
                                click: function ($event) {
                                  return _setup.onTagClick(tag)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-subtitle-2 text--text text-no-wrap",
                                  attrs: { "data-qa": "reviews_tags_name" },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(tag.name) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center pr-4" },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "ui-icon-heart-active ui-icon-fz-big text-lpu-branding-color-primary flex-shrink-0",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-body-2 text--text ml-1",
                                          attrs: {
                                            "data-qa":
                                              "reviews_tags_count_liked",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(tag.countLikedRates) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "ui-icon-heart-broken ui-icon-fz-big bg-gray-80--text flex-shrink-0",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-body-2 text--text ml-1",
                                          attrs: {
                                            "data-qa":
                                              "reviews_tags_count_disliked",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(tag.countDislikedRates) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    })
                  },
                },
              ],
              null,
              false,
              2468069327
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }